function submit3DSecureChallenge(acsURL, creq) {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = acsURL;
  form.target = '_self'; // or '_blank' or an iframe if you want inline challenge

  const input = document.createElement('input');
  input.type = 'hidden';
  input.name = 'creq';
  input.value = creq;
  form.appendChild(input);

  document.body.appendChild(form);
  form.submit();
}

export default submit3DSecureChallenge;
